module.exports = __webpack_public_path__ + "img/apertura.a86d12cc.svg";